import ProjectSession from "../project-session";

export enum SourceType {
    CUSTOM      = 'custom',
    GENERIC     = 'generic',
    INHERITED   = 'inherited',
}

const debug = false
// const debug = "ProjectPropertyLookup"

export default class ProjectPropertyLookup {

    public projectId        : ID
    public project          : ProjectSession
    public sourceType       : SourceType | null
    public sourceProjectId  : ID | null

    constructor(projectId: ID) {

        this.projectId  = projectId
        this.project    = gd.session.projects.get(this.projectId)!

        debug && console.log(debug, this.project, this.projectId)

        this.sourceType         = null; // custom, generic, inherited
        this.sourceProjectId    = null; // inherited from project id
    }

    findAllParents = () => {
        return gd.session.projects.getAllParents(this.projectId).reverse()
    }

    isCustom    = () => this.sourceType === SourceType.CUSTOM
    isGeneric   = () => this.sourceType === SourceType.GENERIC
    isInherited = () => this.sourceType === SourceType.INHERITED
}